export default __webpack_public_path__ + "static/media/1.7fe4f4ca.png";